
<div class="float-left chatbox-wrapper wow fadeInDown" data-wow-duration="1.2s" data-wow-delay=".2s">
    <div class="chatbox-toggle glyphicon glyphicon-question-sign" style="background-color: #FFD700;">
      <i class='bx bx-message-dots'></i>
    </div>
    <div class="chatbox-message-wrapper">
      <div class="chatbox-message-header">
        <div class="chatbox-message-profile"> 
          <img class="chatbox-message-image logo_eric"  alt="">
          <div>
            <h4 class="chatbox-message-name">Eric Vofack</h4>
            <p class="chatbox-message-status">online</p>
          </div>
        </div>
        <div class="chatbox-message-dropdown">
          <i class='bx bx-dots-vertical-rounded chatbox-message-dropdown-toggle'></i>
          <ul class="chatbox-message-dropdown-menu">
            <li>
              <a href="#">Search</a>
            </li>
            <li>
              <a href="#">Report</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="chatbox-message-content">
        <h4 class="chatbox-message-no-message">You don't have message yet!</h4>
      </div>
      <div class="chatbox-message-bottom">
        <form action="#" class="chatbox-message-form">
          <textarea rows="1" id="submit" placeholder="Type message..." class="chatbox-message-input"></textarea>
          <button type="submit" class="chatbox-message-submit float-rigth"><i class='bx bx-send glyphicon glyphicon-send' ></i></button>
        </form>
      </div>
    </div>
  </div>
